import React, { useState } from 'react';

export default function SplitBillName(props) {
  const [name, setName] = useState('');

  return (
    <div className="split-bill">
      <div className="split-bill-amount-input-container">
        <h3>Please enter your initials</h3>
        <input
          className="initials-input"
          type="text"
          value={name}
          onChange={e => setName(e.target.value.toUpperCase())}
          maxLength={2}
          onKeyDown={e => {
            if (e.key === 'Enter') props.assignName(name);
          }}
        />
        <div className="split-bill-menu-container">
          <button
            className="btn btn-primary split-bill-left split-bill-menu-option"
            onClick={props.handleBackButton}
          >
            Back
          </button>
          <button
            className="btn btn-primary split-bill-right split-bill-menu-option"
            onClick={() => props.assignName(name)}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}